module.exports = __webpack_public_path__ + "img/waves.5f3c659d.svg";